export default "__VITE_ASSET__B15O2olG__"